var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyderabad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.697,
    height: 55.712,
    viewBox: "0 0 55.697 55.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(-1108 -336.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20453",
    "data-name": "Path 20453",
    d: "M3130.585-223.234c1.661-1.509,3.6-1.465,5.524-1.3a5.56,5.56,0,0,1,4.907,5.424c.03.99,0,1.982,0,2.853,1.041-.8,2.043-1.674,3.155-2.381a7.339,7.339,0,0,1,4.051-1.137,30.328,30.328,0,0,1,4.653.269,8.577,8.577,0,0,1,4.957,2.957l.488.544c0-1.132-.025-2.123,0-3.112a5.529,5.529,0,0,1,4.974-5.416c2.495-.127,3.258-.253,5.459,1.212.019-.172.042-.318.05-.465s-.005-.281,0-.42a19.112,19.112,0,0,0-.92-7.383c-.259-.767-.076-1.044.657-1.421a.541.541,0,0,0,.249-.394,33.333,33.333,0,0,0-.031-4.2c-.143-1.238-.629-2.433-.887-3.662-.071-.338.038-.99.228-1.06.923-.344.745-1.065.693-1.713a20.383,20.383,0,0,1,1.054-7.487c.646-2.183,1.2-4.393,1.783-6.595.143-.541.351-.994.992-1.026.526-.027.845.3,1.043,1.039.876,3.26,1.759,6.519,2.617,9.784a6.362,6.362,0,0,1,.188,1.477c.026,1.24.014,2.481,0,3.722,0,.289.044.458.376.561a.914.914,0,0,1,.623,1.191,2.1,2.1,0,0,1-.081.288,18.934,18.934,0,0,0-.921,7.5c.015.323.031.531.427.648a.88.88,0,0,1,.587,1.106,1.835,1.835,0,0,1-.081.288,21.35,21.35,0,0,0-.948,7.44c.064,6.4.022,12.807.021,19.21,0,1.2-.246,1.453-1.425,1.453h-50.787c-1.179,0-1.424-.249-1.424-1.454,0-7.024-.033-14.048.024-21.071a16.715,16.715,0,0,0-.752-4.826c-.089-.307-.172-.616-.248-.926a.978.978,0,0,1,.651-1.288.639.639,0,0,0,.31-.461,32.779,32.779,0,0,0-.02-4.019,22.953,22.953,0,0,0-.8-3.313c-.305-1.171-.312-1.167.683-1.85a.523.523,0,0,0,.144-.238.381.381,0,0,0,.007-.179c-.4-3.652.629-7.085,1.6-10.528.451-1.6.867-3.2,1.3-4.8a.911.911,0,0,1,.95-.754.916.916,0,0,1,.907.735c.029.1.059.191.084.287.716,2.662,1.33,5.357,2.177,7.977a21.769,21.769,0,0,1,.653,6.883.665.665,0,0,0,.459.758c.264.113.4.57.543.9.052.119-.034.312-.087.461a19.265,19.265,0,0,0-.915,7.563c.015.315.01.543.418.652a.842.842,0,0,1,.588.994,2.377,2.377,0,0,1-.134.582,19.577,19.577,0,0,0-.866,7.748C3130.538-223.533,3130.555-223.455,3130.585-223.234Zm-.019,17.83h8.492v-11.443h-8.492Zm29.717-11.466V-205.4h8.482V-216.87Zm-2.079,5.718a7.552,7.552,0,0,0-5-6.313,13.462,13.462,0,0,0-4.87-.4,7.193,7.193,0,0,0-4.688,1.872,7.41,7.41,0,0,0-2.538,4.84Zm-29.631,5.771V-227.23h-3.748v21.849Zm42.193-21.849v21.839h3.761V-227.23Zm-12.475,18.07h-17.235v3.766h17.235Zm-27.71-9.684h8.487a3.544,3.544,0,0,0-2.67-3.678,10.949,10.949,0,0,0-2.385-.122A3.556,3.556,0,0,0,3130.582-218.844Zm38.193.008a3.587,3.587,0,0,0-3.594-3.818c-.54-.007-1.082-.018-1.62.01a3.558,3.558,0,0,0-3.256,3.808Zm-43.944-27.611v3.761h3.737v-3.761Zm45.921,3.772h3.763v-3.751h-3.763Zm-45.943,9.592h3.754v-3.748h-3.754Zm49.725.013v-3.749h-3.761v3.749Zm-47.787-21.2h-.117l-1.552,5.82h3.223Zm44.295,5.82h3.231l-1.564-5.827-.112.006Zm-46.988,7.77c.151.587.27,1.129.443,1.654.037.11.273.215.419.217q1.768.026,3.537,0c.145,0,.381-.106.417-.215.175-.524.295-1.065.449-1.656Zm45.969,0c.152.584.272,1.107.432,1.617a.448.448,0,0,0,.327.254q1.889.026,3.777,0a.4.4,0,0,0,.3-.223c.158-.527.283-1.064.433-1.649Zm-45.967,9.617c.149.582.267,1.123.439,1.647a.522.522,0,0,0,.41.23c1.179.018,2.359.016,3.538,0,.141,0,.377-.066.406-.154.177-.555.308-1.124.463-1.726Zm45.97.008c.151.578.271,1.119.444,1.642a.522.522,0,0,0,.409.228c1.179.018,2.359.02,3.538,0a.568.568,0,0,0,.442-.265c.173-.505.282-1.032.428-1.6Z",
    transform: "translate(-2013.826 595.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20454",
    "data-name": "Path 20454",
    d: "M3212.9-221.481c.387-.583.709-1.044,1-1.523a1.211,1.211,0,0,0,.184-.583c.015-1.461.005-2.922.01-4.383,0-.781.331-1.182.957-1.183s.96.4.962,1.178c0,1.441-.014,2.882.016,4.322a1.855,1.855,0,0,0,.308.764c.242.444.512.874.742,1.263a30.766,30.766,0,0,1,4.131.98,13.46,13.46,0,0,1,8.907,10.872,51.659,51.659,0,0,1,.292,7.539.922.922,0,0,1-.976.928.95.95,0,0,1-.924-.988c-.017-1.239-.005-2.478-.005-3.762h-26.871c-.009.189-.026.382-.027.575,0,1.061.01,2.122-.008,3.182a.952.952,0,0,1-.919.993.9.9,0,0,1-.967-.8c-.008-3.787-.383-7.61,1.315-11.211A13.752,13.752,0,0,1,3212.9-221.481Zm-11.211,13.426h26.751c-.024-.29-.03-.549-.07-.8a11.833,11.833,0,0,0-.241-1.295c-1.339-4.911-4.332-8.2-9.427-9.186a28.448,28.448,0,0,0-5.319-.2C3206.6-219.548,3201.963-213.805,3201.692-208.055Z",
    transform: "translate(-2079.211 570.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20455",
    "data-name": "Path 20455",
    d: "M3237.632-70.732c0,.48.019.962-.005,1.441a.912.912,0,0,1-.971.924.9.9,0,0,1-.929-.9q-.037-1.5,0-3a.889.889,0,0,1,.937-.891.906.906,0,0,1,.963.929C3237.651-71.734,3237.632-71.233,3237.632-70.732Z",
    transform: "translate(-2109.475 439.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20456",
    "data-name": "Path 20456",
    d: "M3273.632-70.747c0,.48.017.961-.005,1.441a.911.911,0,0,1-.959.937.906.906,0,0,1-.946-.949q-.031-1.44,0-2.882a.907.907,0,0,1,.93-.964.918.918,0,0,1,.979.976C3273.647-71.708,3273.633-71.227,3273.632-70.747Z",
    transform: "translate(-2139.71 439.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20457",
    "data-name": "Path 20457",
    d: "M3307.74-70.8c0-.46-.013-.921,0-1.381a.921.921,0,0,1,.971-.985.9.9,0,0,1,.938.955q.029,1.44,0,2.881a.908.908,0,0,1-.937.958.925.925,0,0,1-.972-.988C3307.726-69.836,3307.74-70.317,3307.74-70.8Z",
    transform: "translate(-2169.97 439.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20458",
    "data-name": "Path 20458",
    d: "M3343.74-70.8c0-.46-.014-.921,0-1.381a.921.921,0,0,1,.971-.985.9.9,0,0,1,.938.955q.029,1.44,0,2.882a.909.909,0,0,1-.937.958.924.924,0,0,1-.971-.988C3343.726-69.836,3343.74-70.316,3343.74-70.8Z",
    transform: "translate(-2200.207 439.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20459",
    "data-name": "Path 20459",
    d: "M3176.411,16.525V5.082h8.492V16.525Z",
    transform: "translate(-2059.672 373.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20460",
    "data-name": "Path 20460",
    d: "M3362.022,4.94h8.482V16.412h-8.482Z",
    transform: "translate(-2215.566 373.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20461",
    "data-name": "Path 20461",
    d: "M3259.34,5.246h-17.1a7.412,7.412,0,0,1,2.538-4.84,7.194,7.194,0,0,1,4.688-1.872,13.461,13.461,0,0,1,4.87.4A7.551,7.551,0,0,1,3259.34,5.246Z",
    transform: "translate(-2114.963 379.245)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20462",
    "data-name": "Path 20462",
    d: "M3144.3-37.923h-3.748V-59.772h3.748Z",
    transform: "translate(-2029.553 428.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20463",
    "data-name": "Path 20463",
    d: "M3427.5-59.77h3.761v21.839H3427.5Z",
    transform: "translate(-2270.563 428.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20464",
    "data-name": "Path 20464",
    d: "M3259.174,53.1v3.766h-17.235V53.1Z",
    transform: "translate(-2114.708 333.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20465",
    "data-name": "Path 20465",
    d: "M3176.484-27.378a3.555,3.555,0,0,1,3.431-3.8,10.949,10.949,0,0,1,2.385.122,3.543,3.543,0,0,1,2.67,3.678Z",
    transform: "translate(-2059.728 404.178)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20466",
    "data-name": "Path 20466",
    d: "M3370.515-27.415h-8.469a3.558,3.558,0,0,1,3.256-3.808c.539-.029,1.08-.017,1.62-.01A3.587,3.587,0,0,1,3370.515-27.415Z",
    transform: "translate(-2215.567 404.222)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20467",
    "data-name": "Path 20467",
    d: "M3140.59-179.8h3.737v3.761h-3.737Z",
    transform: "translate(-2029.586 528.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20468",
    "data-name": "Path 20468",
    d: "M3427.414-175.922v-3.751h3.763v3.751Z",
    transform: "translate(-2270.489 528.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20469",
    "data-name": "Path 20469",
    d: "M3140.456-115.993v-3.748h3.754v3.748Z",
    transform: "translate(-2029.474 478.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20470",
    "data-name": "Path 20470",
    d: "M3431.309-115.917h-3.761v-3.749h3.761Z",
    transform: "translate(-2270.601 478.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20471",
    "data-name": "Path 20471",
    d: "M3143.807-228.642l1.553,5.819h-3.223l1.552-5.82Z",
    transform: "translate(-2030.885 570.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20472",
    "data-name": "Path 20472",
    d: "M3429.232-222.851l1.556-5.821.112-.006,1.564,5.827Z",
    transform: "translate(-2272.015 570.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20473",
    "data-name": "Path 20473",
    d: "M3135.747-143.754h5.266c-.154.591-.274,1.132-.449,1.656-.036.109-.272.213-.417.215q-1.768.026-3.537,0c-.146,0-.383-.107-.42-.217C3136.017-142.625,3135.9-143.167,3135.747-143.754Z",
    transform: "translate(-2025.519 498.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20474",
    "data-name": "Path 20474",
    d: "M3422.871-143.782h5.265c-.149.585-.274,1.122-.433,1.649a.4.4,0,0,1-.3.223q-1.889.024-3.777,0a.447.447,0,0,1-.327-.254C3423.143-142.675,3423.023-143.2,3422.871-143.782Z",
    transform: "translate(-2266.673 498.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20475",
    "data-name": "Path 20475",
    d: "M3135.76-83.717h5.256c-.155.6-.286,1.172-.463,1.726-.028.088-.264.153-.405.154-1.179.012-2.359.015-3.538,0a.523.523,0,0,1-.41-.23C3136.027-82.594,3135.909-83.135,3135.76-83.717Z",
    transform: "translate(-2025.53 448.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20476",
    "data-name": "Path 20476",
    d: "M3422.888-83.67h5.261c-.146.571-.256,1.1-.428,1.6a.57.57,0,0,1-.442.265c-1.179.022-2.359.02-3.538,0a.522.522,0,0,1-.409-.228C3423.159-82.551,3423.039-83.092,3422.888-83.67Z",
    transform: "translate(-2266.688 448.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20477",
    "data-name": "Path 20477",
    d: "M3212.276-157.761c.271-5.75,4.909-11.494,11.694-11.487a28.45,28.45,0,0,1,5.319.2c5.094.983,8.088,4.275,9.426,9.186a11.832,11.832,0,0,1,.241,1.295c.04.253.046.512.07.8Z",
    transform: "translate(-2089.795 520.154)",
    fill: "#0499bc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyderabad);
export default __webpack_public_path__ + "static/media/hyderabad.89365f82aeb90dcc14dd4273df03abb0.svg";
export { ForwardRef as ReactComponent };